import { create } from 'zustand';

const useProjectInfoStore = create((set) => ({
  projectInfo: null,
  setProjectInfo: (projectInfo) => set({ projectInfo }),
}));

export default useProjectInfoStore;
